/** Sync cross-frame (Labo page ↔ iframe DevTools) en développement uniquement. */

export const DEV_MAINTENANCE_FORCED_STORAGE_KEY = 'monorga.dev.maintenanceForced'

export const DEV_LAB_TOAST_CHANNEL = 'monorga-dev-lab-toasts'

type DevLabToastPushMessage = {
  type: 'push'
  originId: string
  variant: 'success' | 'error' | 'warning' | 'info'
  title: string
  description: string
  durationMs?: number
}

type DevLabToastClearMessage = {
  type: 'clear'
  originId: string
}

type DevLabToastDurationMessage = {
  type: 'setDefaultDuration'
  originId: string
  ms: number
}

export type DevLabToastMessage =
  | DevLabToastPushMessage
  | DevLabToastClearMessage
  | DevLabToastDurationMessage

export function createDevLabOriginId(): string {
  if (typeof globalThis.crypto?.randomUUID === 'function') {
    return globalThis.crypto.randomUUID()
  }
  return `dev-lab-${Date.now()}-${Math.random().toString(36).slice(2, 9)}`
}
